module.exports = __webpack_public_path__ + "static/media/GS.3fda3bab.png";